import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../_metronic/_partials/controls";
import { BlockOrg } from "../../../../RoleChecker";
import Select from 'react-select'
import AsyncSelect from 'react-select/async';
import { getHewanKurbanAll, searchHewanKurban } from "../../../Donation/_redux/hewan-kurban/hewanKurbanCrud";
import { genOptionLoader } from "../../../../../_metronic/_helpers/fetchUtils";
import { promiseTuplify } from "../../../../../_metronic/_helpers/promiseUtils";
import { getPeriodeKurbanAll } from "../../../Donation/_redux/periode-kurban/periodeKurbanCrud";
import { getPartnerAll, searchPartner } from "../../../Partner/_redux/partnerCrud";
import { getAreaAll, searchArea } from "../../../Area/_redux/areaCrud";

const PartnerQuotaSchema = Yup.object().shape({
  thk_livestock_uuid: Yup.string().required("Hewan wajib dipilih"),
  thk_partner_uuid: Yup.string().required("Mitra wajib dipilih"),
  thk_area_uuid: Yup.string().required("Wilayah wajib dipilih"),
  description: Yup.string().required("Deskripsi wajib diisi"),
  price: Yup.number().required("Harga wajib diisi"),
  qty: Yup.number().required("Jumlah wajib diisi"),
})

export const PartnerQuotaEditForm = ({
  savePartnerQuota,
  actionsLoading,
  partnerQuota,
}) => {
  const [partnerOptions, setPartnerOptions] = useState([]);
  const [areaOptions, setAreaOptions] = useState([]);
  const [livestockOptions, setLivestockOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const [res] = await promiseTuplify(Promise.all([
        searchPartner(`keyword=`),
        searchArea('keyword='),
        searchHewanKurban('type_not=17_SAPI')
      ]));
      
      const [partnerRes, areaRes, livestockRes] = res ?? [];
      const {data: partnerData = {}} = partnerRes ?? {};
      const {data: areaData = {}} = areaRes ?? {};
      const {data: livestockData = {}} = livestockRes ?? {};
      const {data: {items: partnerItems = []}} = partnerData ?? {};
      const {data: {items: areaItems = []}} = areaData ?? {};
      const {data: {items: livestockItems = []}} = livestockData ?? {};

      setPartnerOptions(partnerItems.map(({uuid, name}) => ({label: name, value: uuid})));
      setAreaOptions(areaItems.map(({uuid, name}) => ({label: name, value: uuid})));
      setLivestockOptions(livestockItems.map(({uuid, name}) => ({label: name, value: uuid})));
    })();
  }, []);
  
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={partnerQuota}
        validationSchema={PartnerQuotaSchema}
        onSubmit={(values) => {
          savePartnerQuota(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <>
            <Modal.Body className="overlay overlay-block cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  <div className="col-md-6">
                    <label htmlFor="thk_partner_uuid">Mitra</label>
                    <AsyncSelect 
                      name="thk_partner_uuid"
                      defaultOptions={partnerOptions}
                      loadOptions={genOptionLoader(searchPartner, ({uuid, name}) => ({label: name, value: uuid}))}
                      value={values.thk_partner ? {value: values.thk_partner.value, label: values.thk_partner.name} : {}}
                      onChange={({label, value}) => {
                        setFieldValue('thk_partner_uuid', value);
                        setFieldValue('thk_partner', {uuid: value, name: label});
                      }}
                    />
                    <ErrorMessage name="thk_partner_uuid" />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="thk_livestock_uuid">Hewan Kurban</label>
                    <AsyncSelect 
                      name="thk_livestock_uuid"
                      defaultOptions={livestockOptions}
                      loadOptions={
                        genOptionLoader(
                          (query) => searchHewanKurban(`type_not=17_SAPI&${query}`), 
                            ({uuid, name}) => ({label: name, value: uuid}))
                      }
                      value={values.thk_livestock ? {value: values.thk_livestock.value, label: values.thk_livestock.name} : {}}
                      onChange={({label, value}) => {
                        setFieldValue('thk_livestock_uuid', value);
                        setFieldValue('thk_livestock', {uuid: value, name: label});
                      }}
                    />
                    <ErrorMessage name="thk_livestock_uuid" />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label htmlFor="qty">Jumlah</label>
                    <input
                      className="form-control"
                      name="qty"
                      type="number"
                      placeholder="1000"
                      label="Jumlah"
                      value={values.qty}
                      onChange={(e) => setFieldValue('qty', e.target.value)}
                    />
                    <ErrorMessage name="qty" />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="thk_area_uuid">Wilayah</label>
                    <AsyncSelect 
                      name="thk_area_uuid"
                      defaultOptions={areaOptions}
                      loadOptions={genOptionLoader(searchArea, ({uuid, name}) => ({label: name, value: uuid}))}
                      value={values.thk_area ? {value: values.thk_area.value, label: values.thk_area.name} : {}}
                      onChange={({label, value}) => {
                        setFieldValue('thk_area_uuid', value);
                        setFieldValue('thk_area', {uuid: value, name: label});
                      }}
                    />
                    <ErrorMessage name="thk_area_uuid" />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label htmlFor="price">Harga</label>
                    <input
                      className="form-control"
                      name="price"
                      type="number"
                      placeholder="1000"
                      label="Jumlah"
                      value={values.price}
                      onChange={(e) => setFieldValue('price', e.target.value)}
                    />
                    <ErrorMessage name="price" />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="description">Deskripsi</label>
                    <textarea
                      className="form-control"
                      name="description"
                      type="textarea"
                      placeholder="Kuota..."
                      label="Deskripsi"
                      value={values.description}
                      onChange={(e) => setFieldValue('description', e.target.value)}
                    />
                    <ErrorMessage name="description" />
                  </div>
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              {BlockOrg() && (
                <button
                  type="submit"
                  onClick={() => handleSubmit()}
                  className="btn btn-primary btn-elevate"
                >
                  Save
                </button>
              )}
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
